var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { FormInput } from 'components/form/FormInput';
import { Icon } from 'components/Icon';
import { Money } from 'components/Money';
import { DealItemDiscountedPrice } from './DealItemDiscountedPrice';
import { DateTime } from 'components/DateTime';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { calculatePriceCurrency, getMarkup, getMargin, getPricePerUnitFromMarkup, getPricePerUnitFromMargin } from 'helpers/Pricing';
import { useModal } from 'components/modal/ModalStack';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { DealModalDeleteConfirmation } from '../../modal/DealModalDeleteConfirmation';
import { DealItemPickerPackageDetail } from '../../picker/DealItemPickerPackageDetail';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useUser } from 'components/user/UserProvider';
import { Button } from 'components/Button';
import { DealItemEditModal } from '../../modal/DealItemEditModal';
import { DealAvailabilityModal } from '../../../modal/DealAvailabilityModal';
import { formatFieldValue } from 'helpers/Field';
import i18n from 'components/translation/i18n';
import classNames from 'classnames';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { QuoteMedia } from 'modules/public/quote/components/QuoteMedia';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { showBundledQuoteConfigurationQuantity } from 'helpers/quoteBundled';
import { getConfigurationEffectiveQuantity, getConfigurationQuantitySuffix } from 'helpers/DealQuantity';
import '../DealItemPanelGroupContent.scss';
import { useAccount } from 'components/account/AccountProvider';
export function PackageListItem(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    const { data, editable, discountRep, hideSKU, item, pricingDisplay, pricingParametersDisplay, quantityType } = props;
    const modal = useModal();
    const user = useUser();
    const breakpoint = useBreakpoint();
    const _7 = useDealConfiguratorContext(), { onItemPriceChange, deal, proposePackage, changePriceDisplay, hideDealItemConfiguration, includePackage, onPackageQuantityChange, updatePackageFieldValues, updateMarkupPerItem, updatePackages, onMoveItemConfiguration, configurationFields, hasDealItemConfigurationTime: hasDealItemConfigurationTimeCfg } = _7, dealConfiguratorContext = __rest(_7, ["onItemPriceChange", "deal", "proposePackage", "changePriceDisplay", "hideDealItemConfiguration", "includePackage", "onPackageQuantityChange", "updatePackageFieldValues", "updateMarkupPerItem", "updatePackages", "onMoveItemConfiguration", "configurationFields", "hasDealItemConfigurationTime"]);
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const quoteContext = useQuoteContext();
    const hasDealItemConfigurationTime = hasDealItemConfigurationTimeCfg ||
        quoteContext.hasDealItemConfigurationTime;
    const dealDetailContext = useDealDetailContext();
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const dealValue = deal !== null && deal !== void 0 ? deal : quoteContext.deal;
    const showLineDiscount = !editable && !!(dealValue === null || dealValue === void 0 ? void 0 : dealValue.showDiscount) && pricingDisplay !== 'BUNDLED';
    const effectiveQuantity = getConfigurationEffectiveQuantity(data.quantity, (_a = data.package) === null || _a === void 0 ? void 0 : _a.quantityCalculation, dealValue);
    const quantitySuffix = getConfigurationQuantitySuffix((_b = data.package) === null || _b === void 0 ? void 0 : _b.quantityCalculation, dealValue);
    const showConfigurationQuantity = showBundledQuoteConfigurationQuantity(data, pricingDisplay, editable);
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const itemSorting = (_e = JSON.parse((_d = (_c = configurationFields.find((conf) => conf.fieldKey === 'ITEM_SORTING')) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '{}')) === null || _e === void 0 ? void 0 : _e.value;
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [openModalEditFields, setOpenModalEditFields] = useState(false);
    const [openModalAvailability, setOpenModalAvailability] = useState(false);
    const [costPrice, setCostPrice] = useState(calculatePriceCurrency((data === null || data === void 0 ? void 0 : data.package) && (data === null || data === void 0 ? void 0 : data.package.price) ? data === null || data === void 0 ? void 0 : data.package.price : 0, deal === null || deal === void 0 ? void 0 : deal.currency));
    const [amount, setAmount] = useState((_f = data.price) !== null && _f !== void 0 ? _f : 0);
    const dealerDiscount = (discountRep * costPrice) / 100;
    const dealerPrice = costPrice - dealerDiscount;
    const [markup, setMarkup] = useState(getMarkup(dealerPrice, amount).toFixed(0).toString());
    const [margin, setMargin] = useState(getMargin(dealerPrice, amount).toFixed(0).toString());
    const [discount, setDiscount] = useState(Number((((dealerPrice - amount) / dealerPrice) * 100).toFixed(2)));
    const [pricePerUnit, setPricePerUnit] = useState(amount.toFixed(2).toString());
    const [userInputMarkup, setUserInputMarkup] = useState(false);
    const [userInputMargin, setUserInputMargin] = useState(false);
    const [userInputDiscount, setUserInputDiscount] = useState(false);
    const [userInputPricePerUnit, setUserInputPricePerUnit] = useState(true);
    const [quantity, setQuantity] = useState(data.quantity);
    const markupRef = useRef(null);
    const marginRef = useRef(null);
    const discountRef = useRef(null);
    const pricePerUnitRef = useRef(null);
    useEffect(() => {
        setPricePerUnit(dealerPrice.toFixed(2));
    }, [amount]);
    useEffect(() => {
        var _a;
        setQuantity(data.quantity);
        const newPrice = (_a = data.price) !== null && _a !== void 0 ? _a : 0;
        setPricePerUnit(Number.isFinite(newPrice) ? newPrice.toFixed(2) : '0');
        setMarkup(getMarkup(dealerPrice, newPrice).toFixed(0).toString());
        setMargin(getMargin(dealerPrice, newPrice).toFixed(0).toString());
        setDiscount(dealerPrice !== 0
            ? Number((((dealerPrice - newPrice) / dealerPrice) * 100).toFixed(2))
            : 0);
    }, [data, dealerPrice]);
    useEffect(() => {
        setCostPrice(calculatePriceCurrency((data === null || data === void 0 ? void 0 : data.package) && (data === null || data === void 0 ? void 0 : data.package.price) ? data === null || data === void 0 ? void 0 : data.package.price : 0, deal === null || deal === void 0 ? void 0 : deal.currency));
    }, [deal === null || deal === void 0 ? void 0 : deal.currency]);
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChange = (value) => {
        setQuantity(Number(value));
    };
    /**
     * @function onQuantityChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChangeOnBlur = () => {
        if (quantity !== data.quantity) {
            const onQuantityChangeHandler = deal
                ? onPackageQuantityChange
                : quoteContext.onPackageQuantityChange;
            onQuantityChangeHandler(item, data, quantity);
        }
    };
    /**
     * @function onMarkupChange
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMarkup(dealerPrice, Number(value));
        setMarkup(value);
        updateMarkupPerItem(data.id, Number(value), false);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onMarginChange
     * @since 1.0.0
     * @hidden
     */
    const onMarginChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMargin(dealerPrice, Number(value));
        setMargin(value);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onDiscountChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChange = (value) => {
        const pricePerUnit = dealerPrice - dealerPrice * (Number(value) / 100);
        setDiscount(Number(value));
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onPricePerUnitChange
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitChange = (value) => {
        const markup = getMarkup(dealerPrice, Number(value)).toFixed(0);
        const margin = getMargin(dealerPrice, Number(value)).toFixed(0);
        const discount = ((dealerPrice - Number(value)) / dealerPrice) * 100;
        setPricePerUnit(value);
        setMarkup(markup);
        setMargin(margin);
        setDiscount(Number(discount.toFixed(2)));
        updateMarkupPerItem(data.id, Number(markup), false);
    };
    /**
     * @function onPriceChange
     * @since 1.0.0
     * @hidden
     */
    const onPriceChange = (value) => {
        if (item.packages && (data === null || data === void 0 ? void 0 : data.id)) {
            const tempPackages = [...item.packages];
            const packageIndex = item.packages.findIndex((p) => p.id === (data === null || data === void 0 ? void 0 : data.id));
            if (packageIndex > -1) {
                tempPackages[packageIndex] = Object.assign(Object.assign({}, tempPackages[packageIndex]), { price: value });
                onItemPriceChange &&
                    onItemPriceChange(Object.assign(Object.assign({}, item), { packages: tempPackages }));
            }
        }
    };
    /**
     * @function onItemPriceOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onPriceOnBlur = () => {
        onPriceChange(Number(pricePerUnit));
    };
    /**
     * @function onMarkupClick
     * @since 1.0.0
     * @hidden
     */
    const onMarkupClick = () => {
        var _a;
        setUserInputMarkup(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = markupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarginClick
     * @since 1.0.0
     * @hidden
     */
    const onMarginClick = () => {
        var _a;
        setUserInputMargin(true);
        setUserInputMarkup(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = marginRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDiscountClick
     * @since 1.0.0
     * @hidden
     */
    const onDiscountClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(false);
        setUserInputDiscount(true);
        setUserInputPricePerUnit(false);
        (_a = discountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onProfitClick
     * @since 1.0.0
     * @hidden
     */
    const onProfitClick = () => {
        var _a;
        setUserInputPricePerUnit(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputMarkup(false);
        (_a = pricePerUnitRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onManagePackage
     * @since 1.0.0
     * @hidden
     */
    function onManagePackage(value) {
        var _a;
        const itemValue = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
        switch (value) {
            case 'propose':
                proposePackage(itemValue !== null && itemValue !== void 0 ? itemValue : item, data);
                break;
            case 'include':
                includePackage(item, data);
                break;
            case 'alternative':
                updatePackages(itemValue !== null && itemValue !== void 0 ? itemValue : item, (_a = data.package) === null || _a === void 0 ? void 0 : _a.id);
                break;
            case 'hide':
                hideDealItemConfiguration(item, data, 'package');
                break;
            case 'showAmount':
                changePriceDisplay(item, data, true, 'package', 'AMOUNT');
                break;
            case 'includedWithoutPrice':
                changePriceDisplay(item, data, false, 'package', 'INCLUDED');
                break;
            case 'includeWithPrice':
                changePriceDisplay(item, data, true, 'package', 'INCLUDED');
                break;
            case 'hideAmount':
                changePriceDisplay(item, data, true, 'package', 'NONE');
                break;
            case 'default':
                changePriceDisplay(item, data, true, 'package', 'DEFAULT');
                break;
            case 'moveUp':
                onMoveItemConfiguration(item, data, 'package', 'up');
                break;
            case 'moveDown':
                onMoveItemConfiguration(item, data, 'package', 'down');
                break;
            case 'checkAvailability':
                setOpenModalAvailability(true);
                break;
            case 'delete':
                setOpenModalDelete(true);
                break;
        }
    }
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = () => {
        if (openModalDelete) {
            setOpenModalDelete(false);
        }
        if (openModalEditFields) {
            setOpenModalEditFields(false);
        }
        if (openModalAvailability) {
            setOpenModalAvailability(false);
        }
    };
    /**
     * @function onShowPackageDetails
     * @since 1.0.0
     * @hidden
     * */
    const onShowPackageDetails = () => {
        var _a;
        if (data.package) {
            modal.present({
                title: (_a = data.package.sku) !== null && _a !== void 0 ? _a : t('Package details'),
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(DealItemPickerPackageDetail, { data: data.package })
            });
        }
    };
    /**
     * @function onEditPress
     * @since 1.0.0
     * @hidden
     */
    function onEditPress() {
        setOpenModalEditFields(true);
    }
    /**
     * @component onPressRemovePackage
     * @since 1.0.0
     * @hidden
     */
    const onPressRemovePackage = () => {
        var _a;
        const itemWithProposedPackage = (_a = quoteContext.deal) === null || _a === void 0 ? void 0 : _a.items.find((i) => i.id === item.id);
        quoteContext.proposePackageQuote(itemWithProposedPackage !== null && itemWithProposedPackage !== void 0 ? itemWithProposedPackage : item, data);
    };
    /**
     * @function isAlternativeTo
     * @since 1.0.0
     * @hidden
     */
    function isAlternative(data) {
        var _a, _b;
        const isAlternative = (_b = (_a = dealValue === null || dealValue === void 0 ? void 0 : dealValue.items.find((i) => i.id === item.id)) === null || _a === void 0 ? void 0 : _a.packages) === null || _b === void 0 ? void 0 : _b.find((pack) => { var _a; return pack.alternativeTo === ((_a = data.package) === null || _a === void 0 ? void 0 : _a.id); });
        return !!isAlternative;
    }
    const dropdown = [];
    const visibilityDropdown = [];
    dropdown.push({
        value: 'propose',
        picto: 'heart',
        label: t('Suggest')
    });
    dropdown.push({
        value: 'alternative',
        picto: 'right-left',
        label: t('Alternative')
    });
    if (user.can('calendar.availability.check')) {
        dropdown.push({
            value: 'checkAvailability',
            picto: 'calendar-check',
            label: t('Check availability')
        });
    }
    if (data.priceDisplay === 'INCLUDED') {
        dropdown.push({
            value: 'default',
            picto: 'rotate-left',
            label: t('Reset default pricing')
        });
    }
    else {
        dropdown.push({
            value: 'includedWithoutPrice',
            picto: 'check',
            label: t('Include (Free)')
        });
        dropdown.push({
            value: 'includeWithPrice',
            picto: 'plus',
            label: t('Include (Charged)')
        });
    }
    if (data.priceDisplay !== 'AMOUNT') {
        visibilityDropdown.push({
            value: 'showAmount',
            picto: 'dollar-sign',
            label: t('Show amount')
        });
    }
    else {
        visibilityDropdown.push({
            value: 'hideAmount',
            picto: 'eye-slash',
            label: t('Hide amount')
        });
    }
    if (data.hide) {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye',
            label: t('Show line')
        });
    }
    else {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye-slash',
            label: t('Hide line')
        });
    }
    if (itemSorting === 'ORDER') {
        visibilityDropdown.push({
            value: 'moveUp',
            picto: 'arrow-up',
            label: t('Move up')
        });
        visibilityDropdown.push({
            value: 'moveDown',
            picto: 'arrow-down',
            label: t('Move down')
        });
    }
    visibilityDropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    // Check if item have infos or image
    const hasInfos = !!((_g = data.package) === null || _g === void 0 ? void 0 : _g.infos) || !!((_h = data.package) === null || _h === void 0 ? void 0 : _h.options);
    const isClickable = hasInfos;
    const className = classNames({ 'deal-item-panel-group-content--isClickable': isClickable && !editable }, { 'deal-item-panel-group-content--hide': data.hide }, props.className);
    return editable || (!editable && breakpoint.isAboveOrEqual('md')) ? (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: className, onClick: isClickable && !editable ? onShowPackageDetails : undefined },
            React.createElement("td", { className: "deal-item-panel-group-content-cell--primary", "data-label": t('Package') },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement("div", { className: "deal-item-panel-group-heading-title-caption-title" },
                            React.createElement("div", { className: "deal-item-panel-group-content-cell--primary--title" },
                                !((_j = data.package) === null || _j === void 0 ? void 0 : _j.active) || ((_k = data.package) === null || _k === void 0 ? void 0 : _k.deletedAt) ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : isClickable ? (React.createElement(Button, { style: "picto", picto: ((_l = data.package) === null || _l === void 0 ? void 0 : _l.icon) || 'circle-info', onPress: editable ? onShowPackageDetails : undefined })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true })),
                                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--title", value: (_m = data.package) === null || _m === void 0 ? void 0 : _m.title, onClick: editable ? onShowPackageDetails : undefined })))))),
            hideSKU === 'FALSE' && (React.createElement("td", { "data-label": t('SKU') },
                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--sku", value: (_o = data.package) === null || _o === void 0 ? void 0 : _o.sku }))),
            React.createElement("td", { "data-label": t('Group') }, ((_p = data.package) === null || _p === void 0 ? void 0 : _p.groups) && ((_q = data.package) === null || _q === void 0 ? void 0 : _q.groups.length) > 0 && (React.createElement(Text, { className: classNames({ 'deal-item-panel-group-content-value': true }, {
                    'deal-item-panel-group-content-value--group': (_r = data.package) === null || _r === void 0 ? void 0 : _r.groups
                }), value: ((_s = data.package) === null || _s === void 0 ? void 0 : _s.groups) && ((_t = data.package) === null || _t === void 0 ? void 0 : _t.groups.length) > 0
                    ? (_u = data.package) === null || _u === void 0 ? void 0 : _u.groups[0].title
                    : '' }))),
            hasDealItemConfigurationTime && (React.createElement("td", { className: "field-cell", "data-label": t('Time') }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : (React.createElement(Button, { style: "picto", picto: "clock" })))) : data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : null)),
            quoteDealItemConfigurationFields.length > 0
                ? quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("td", { key: field.id, className: "field-cell" }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, v ? (field.type === 'FILE' ? (React.createElement(Icon, { value: "file" })) : (React.createElement(React.Fragment, null,
                        React.createElement(Text, { className: "deal-item-panel-group-content-value", value: formatFieldValue(v, field.type, field, i18n.language) }),
                        React.createElement(Icon, { value: "pencil" })))) : (React.createElement(Button, { picto: field.type === 'DATE'
                            ? 'calendar'
                            : field.type === 'TIME'
                                ? 'clock'
                                : 'plus', style: "picto" })))) : field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                            ? formatFieldValue(v, field.type, field, i18n.language)
                            : '' }))));
                })
                : null,
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') && (React.createElement("td", { "data-label": t('Quantity'), className: "deal-item-panel-group-content-value--qty" }, editable || (dealValue === null || dealValue === void 0 ? void 0 : dealValue.canEditQuantity) ? (React.createElement(FormInput, { className: "deal-item-panel-group-content-input input-quantity", type: "number", name: "quantity", value: quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: "0", size: "small", suffix: quantitySuffix })) : showConfigurationQuantity ? (React.createElement("div", { className: "deal-item-panel-group-content-value--uneditable-qty" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: quantity.toString() }),
                React.createElement(Case, { is: !!quantitySuffix },
                    React.createElement(Text, { className: "deal-item-panel-group-content-value--unitOfMeasurement", value: quantitySuffix })))) : null)),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Price'), className: "deal-item-panel-group-content-price" },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer discount'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerDiscount })))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer price'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerPrice })))),
            editable && pricingParameters === 'DISCOUNT' && (React.createElement("td", { "data-label": t('Discount') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onDiscountClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputDiscount ? onDiscountChange : undefined, value: discount.toString(), disabled: userInputDiscount ? false : true, className: userInputDiscount ? 'number-input isActive' : 'number-input', ref: discountRef, size: "small" }),
                React.createElement(Icon, { value: userInputDiscount ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARKUP' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Markup') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onMarkupClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMarkup ? onMarkupChange : undefined, value: markup, disabled: userInputMarkup ? false : true, className: userInputMarkup ? 'number-input isActive' : 'number-input', ref: markupRef, size: "small" }),
                React.createElement(Icon, { value: userInputMarkup ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARGIN' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Margin') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onMarginClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMargin ? onMarginChange : undefined, value: margin, disabled: userInputMargin ? false : true, className: userInputMargin ? 'number-input isActive' : 'number-input', ref: marginRef, size: "small" }),
                React.createElement(Icon, { value: userInputMargin ? 'angle-left' : 'angle-right' }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Selling Price') + ' ($)', className: "deal-item-panel-group-content-input input-profit deal-item-panel-group-content-price", onClick: onProfitClick }, editable ? (React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputPricePerUnit ? onPricePerUnitChange : undefined, onBlur: onPriceOnBlur, value: pricePerUnit, disabled: userInputPricePerUnit ? false : true, className: userInputPricePerUnit
                    ? 'number-input isActive'
                    : 'number-input', ref: pricePerUnitRef, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onPriceOnBlur();
                    }
                }, size: "small" })) : data.priceDisplay === 'INCLUDED' ? (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: t('Included') })) : data.priceDisplay === 'AMOUNT' ? (React.createElement(DealItemDiscountedPrice, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })) : null)),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Total'), className: "deal-item-panel-group-content-price" },
                data.priceDisplay === 'INCLUDED' && (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: t('Included') })),
                data.priceDisplay === 'AMOUNT' && (React.createElement(Money, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit) * effectiveQuantity })))),
            React.createElement("td", { "data-label": t('Actions') }, data.priceDisplay === 'INCLUDED' && !editable ? (React.createElement(Icon, { value: "hexagon-check", className: "deal-item-panel-group-content-lock-icon" })) : editable ? (React.createElement("div", { className: "cell-button-actions" },
                React.createElement(ButtonDropdown, { picto: "eye", options: visibilityDropdown, onSelect: onManagePackage, className: "first" }),
                React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManagePackage, className: "last" }))) : isAlternative(data) ? (React.createElement("div", { onClick: (e) => e.stopPropagation() },
                React.createElement(Button, { style: "picto", picto: "right-left", className: "deal-item-panel-group-content-add-proposed-button deal-item-panel-group-content-add-proposed-button--alternative", onPress: onPressRemovePackage }))) : (data.initiallyProposed && (React.createElement("div", { onClick: (e) => e.stopPropagation() },
                React.createElement(Button, { style: "picto", picto: "minus", className: "deal-item-panel-group-content-add-proposed-button", onPress: onPressRemovePackage })))))),
        openModalAvailability && dealValue && (React.createElement(DealAvailabilityModal, { deal: dealValue, onClose: () => setOpenModalAvailability(false), saleItemTitle: (_v = data.package) === null || _v === void 0 ? void 0 : _v.title })),
        openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'package', item: item, configuration: data, onClose: onCloseModal, deleteConfirmationMessage: `${t('Delete')} ${(_w = data.package) === null || _w === void 0 ? void 0 : _w.title}?` })),
        openModalEditFields && (React.createElement(DealItemEditModal, { type: "package", item: data, customFields: quoteDealItemConfigurationFields, hasTime: hasDealItemConfigurationTime, onClose: onCloseModal, onUpdateItem: (updatedItem, applyToAll) => {
                var _a, _b, _c;
                const cfg = updatedItem;
                updatePackageFieldValues(item.id, updatedItem.id, (_a = updatedItem.fieldValues) !== null && _a !== void 0 ? _a : [], applyToAll, hasDealItemConfigurationTime
                    ? ((_b = cfg.startTime) !== null && _b !== void 0 ? _b : null)
                    : undefined, hasDealItemConfigurationTime ? ((_c = cfg.endTime) !== null && _c !== void 0 ? _c : null) : undefined);
                setOpenModalEditFields(false);
            } })))) : (React.createElement("div", { className: "deal-item-panel-group__content--mobile" },
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-row" },
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-picto" }, !((_x = data.package) === null || _x === void 0 ? void 0 : _x.active) || ((_y = data.package) === null || _y === void 0 ? void 0 : _y.deletedAt) ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : isClickable ? (React.createElement(Button, { style: "picto", picto: ((_z = data.package) === null || _z === void 0 ? void 0 : _z.icon) || 'circle-info', onPress: editable ? onShowPackageDetails : undefined })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true }))),
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                React.createElement(Text, { value: (_0 = data.package) === null || _0 === void 0 ? void 0 : _0.title, onClick: editable ? onShowPackageDetails : undefined })),
            pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                data.priceDisplay === 'INCLUDED' && React.createElement(Text, { value: t('Included') }),
                data.priceDisplay === 'AMOUNT' && (React.createElement(Money, { value: Number(pricePerUnit) * effectiveQuantity })))) : null,
            data.priceDisplay === 'INCLUDED' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-actions" },
                React.createElement(Icon, { value: "hexagon-check", className: "deal-item-panel-group-content-lock-icon" }))) : isAlternative(data) ? (React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "deal-item-panel-group__content--mobile-row-actions" },
                React.createElement(Button, { style: "picto", picto: "right-left", className: "deal-item-panel-group-content-add-proposed-button deal-item-panel-group-content-add-proposed-button--alternative", onPress: onPressRemovePackage }))) : data.initiallyProposed ? (React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "deal-item-panel-group__content--mobile-row-actions" },
                React.createElement(Button, { style: "picto", picto: "minus", className: "deal-item-panel-group-content-add-proposed-button", onPress: onPressRemovePackage }))) : (React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-actions" }))),
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow" },
            hideSKU === 'FALSE' && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('SKU')),
                React.createElement(Text, { className: "deal-item-panel-group__content--mobile-subrow--value", value: (_1 = data.package) === null || _1 === void 0 ? void 0 : _1.sku }))),
            ((_2 = data.package) === null || _2 === void 0 ? void 0 : _2.groups) && ((_3 = data.package) === null || _3 === void 0 ? void 0 : _3.groups.length) > 0 && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Category')),
                React.createElement(Text, { value: ((_4 = data.package) === null || _4 === void 0 ? void 0 : _4.groups) && ((_5 = data.package) === null || _5 === void 0 ? void 0 : _5.groups.length) > 0
                        ? (_6 = data.package) === null || _6 === void 0 ? void 0 : _6.groups[0].title
                        : '' }))),
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') &&
                showConfigurationQuantity && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Quantity')),
                React.createElement(Text, { value: quantity.toString() }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE') && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Price')),
                data.priceDisplay === 'INCLUDED' ? (React.createElement(Text, { value: t('Included') })) : data.priceDisplay === 'AMOUNT' ? (React.createElement(DealItemDiscountedPrice, { value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })) : null)),
            quoteDealItemConfigurationFields.length > 0
                ? quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value", key: field.id },
                        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, field.title),
                        field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                                ? formatFieldValue(v, field.type, field, i18n.language)
                                : '' }))));
                })
                : null,
            data.priceDisplay === 'INCLUDED' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Icon, { value: "hexagon-check", className: "deal-item-panel-group-content-lock-icon" }))) : isAlternative(data) ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Button, { style: "picto", picto: "right-left", className: "deal-item-panel-group-content-add-proposed-button deal-item-panel-group-content-add-proposed-button--alternative", onPress: onPressRemovePackage }))) : (data.initiallyProposed && (React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Button, { style: "picto", picto: "minus", className: "deal-item-panel-group-content-add-proposed-button", onPress: onPressRemovePackage })))))));
}
